/* istanbul ignore file */
import * as React from 'react';

import { RefTarget, useRefContext, useVisibility, VisibilityEvents, VisibilityEventType } from '@shared-ui/ref-context';

import { UitkCardAloha, UitkCardAlohaContentSection } from 'uitk-react-cards';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkSticky } from 'uitk-react-sticky';

const VISIBILITY_OPTIONS = {
  thresholds: [1],
};

export const StickyWizardWrapper: React.FC<{}> = ({ children }) => {
  const [stickyVisible, setStickyVisible] = React.useState(false);
  const { getTargets } = useRefContext();
  const targetStickySection = 'wizard';

  const { [targetStickySection]: targetRef } = getTargets([targetStickySection]);
  const targetList = [
    {
      id: targetStickySection,
      ref: targetRef,
    },
  ];

  const onVisibilityChange = React.useCallback(
    (visibilityEvents: VisibilityEvents): void => {
      let targetExit = false;
      Object.keys(visibilityEvents).forEach(sectionName => {
        targetExit = sectionName === targetStickySection && visibilityEvents[sectionName] === VisibilityEventType.EXIT_TOP_COMPLETE;
      });
      setStickyVisible(targetExit);
    },
    [setStickyVisible]
  );

  useVisibility(targetList, onVisibilityChange, VISIBILITY_OPTIONS);

  return (
    <>
      <RefTarget name="wizard" className="uitk-cell">
        {!stickyVisible && children}
      </RefTarget>
      {stickyVisible && (
        <RefTarget name="sticky-wizard" className="uitk-cell">
          <UitkSticky zIndex={299}>
            <UitkSpacing
              className={'elevation-1'}
              margin={{ blockstart: 'two' }}
              padding={{ blockstart: 'twelve', blockend: 'three', inlinestart: 'four', inlineend: 'four' }}
              border={['inlinestart']}
            >
              <UitkCardAloha data-stid="room-and-rates-sticky" overflow={true}>
                <UitkCardAlohaContentSection>{children}</UitkCardAlohaContentSection>
              </UitkCardAloha>
            </UitkSpacing>
          </UitkSticky>
        </RefTarget>
      )}
    </>
  );
};
